<template>
    <v-card>
        <v-container>
            <v-card-title class="mb-5">
                <v-row justify="space-between">
                    {{$vuetify.lang.t('$vuetify.utc.batteryCard.backupbattery')}}
                    <template v-if="utcInfos.isBattSupply">
                        <h6 class="red--text">{{$vuetify.lang.t('$vuetify.utc.batteryCard.utcpoweredbybatteries')}}</h6>
                        <v-icon color="red" size="35">mdi-power</v-icon>
                    </template>
                </v-row>
            </v-card-title>
            <v-row justify="space-around" align="center">
                <!-- <v-col cols="4">
                    <v-row justify="center">
                        <v-icon v-if="utcInfos.isBattSupply" size="55">mdi-battery-charging</v-icon>
                        <v-icon v-else-if="utcInfos.battLevel <= 15" color="red" size="55" >mdi-battery-20</v-icon>
                        <v-icon v-else-if="utcInfos.battLevel <= 50" color="orange" size="55">mdi-battery-40</v-icon>
                        <v-icon v-else-if="utcInfos.battLevel <= 85" color="green" size="55">mdi-battery-80</v-icon>
                        <v-icon v-else color="green" size="55">mdi-battery</v-icon>
                    </v-row>
                    <v-row justify="center">({{utcInfos.battLevel}}%)</v-row>
                </v-col>
                <v-col cols="6">
                    <v-row justify="center"><h3>Maintenance</h3></v-row>
                    <v-row justify="center" align="center">  {{$vuetify.lang.t('$vuetify.utc.batteryCard.last')}}: <h3 class="ml-3">{{ lastChange }}</h3></v-row>
                    <v-row justify="center" align="center">{{$vuetify.lang.t('$vuetify.utc.batteryCard.next')}}: <h3 class="ml-3">{{ nextChange }}</h3></v-row>
                </v-col> -->
                <h3 style="color:grey" >{{$vuetify.lang.t('$vuetify.utc.batteryCard.nobattery')}}</h3>
            </v-row>
        </v-container>
    </v-card> 
</template>
<script>
    export default {
        name: "BatteryCard",
        props: {
            utcInfos: Object
        },
        computed: {
            lastChange() {
                var date = new Date(this.utcInfos.battDateChange)
                return this.dateToFormattedString(date)
            },
            nextChange() {
                var date = new Date(this.utcInfos.battDateChange)
                date.setFullYear(date.getFullYear() + 3)
                return this.dateToFormattedString(date)
            }
        },
        methods: {
            dateToFormattedString(date) {
                let year = date.getFullYear();
                let month = (1 + date.getMonth()).toString().padStart(2, '0');
                let day = date.getDate().toString().padStart(2, '0');
  
                if(this.utcInfos.dateFormat === 'MM/dd/yyyy'){
                    return month+"/"+day+"/"+year
                } else if(this.utcInfos.dateFormat === 'yyyy/MM/dd'){
                    return year+"/"+month+"/"+day
                } else {
                    return day+"/"+month+"/"+year
                }
            },
        }
    }
</script>